/**
 * 可逆加密工具类 (React Native & Web 兼容版本)
 */
class CryptoUtil {
  static KEY = 'locals-prod-secret-key-20151028-xxx';

  /**
   * 将字符串转换为字节数组
   */
  static strToBytes (str) {
    const bytes = [];
    for (let i = 0; i < str.length; i++) {
      bytes.push(str.charCodeAt(i));
    }
    return bytes;
  }

  /**
   * 将字节数组转换为字符串
   */
  static bytesToStr (bytes) {
    return String.fromCharCode.apply(null, bytes);
  }

  /**
   * Base64 编码
   */
  static base64Encode (str) {
    try {
      // React Native 环境
      if (global.Buffer) {
        return global.Buffer.from(str, 'binary').toString('base64');
      }
      // Web 环境
      return btoa(str);
    } catch (e) {
      console.error('Base64编码失败:', e);
      return '';
    }
  }

  /**
   * Base64 解码
   */
  static base64Decode (base64) {
    try {
      // React Native 环境
      if (global.Buffer) {
        return global.Buffer.from(base64, 'base64').toString('binary');
      }
      // Web 环境
      return atob(base64);
    } catch (e) {
      console.error('Base64解码失败:', e);
      return '';
    }
  }

  /**
   * 加密方法
   * @param {string} text - 需要加密的文本
   * @returns {string} - 加密后的字符串
   */
  static encrypt (text) {
    if (!text) return '';

    try {
      // 将文本和密钥转换为字节数组
      const textBytes = this.strToBytes(text);
      const keyBytes = this.strToBytes(this.KEY);
      const result = [];

      // XOR 加密
      for (let i = 0; i < textBytes.length; i++) {
        // eslint-disable-next-line no-bitwise
        result.push(textBytes[i] ^ keyBytes[i % keyBytes.length]);
      }

      // 转换为字符串并进行 Base64 编码
      const encryptedStr = this.bytesToStr(result);
      return this.base64Encode(encryptedStr);
    } catch (error) {
      console.error('加密失败:', error);
      return '';
    }
  }

  /**
   * 解密方法
   * @param {string} encrypted - 加密后的文本
   * @returns {string} - 解密后的字符串
   */
  static decrypt (encrypted) {
    if (!encrypted) return '';

    try {
      // Base64 解码
      const decoded = this.base64Decode(encrypted);
      const encryptedBytes = this.strToBytes(decoded);
      const keyBytes = this.strToBytes(this.KEY);
      const result = [];

      // XOR 解密
      for (let i = 0; i < encryptedBytes.length; i++) {
        // eslint-disable-next-line no-bitwise
        result.push(encryptedBytes[i] ^ keyBytes[i % keyBytes.length]);
      }

      return this.bytesToStr(result);
    } catch (error) {
      console.error('解密失败:', error);
      return '';
    }
  }
}

export default CryptoUtil;
